<template>
  <div>
    <site-header></site-header>
    <div class="c-t-search">
      <div class="c-t-search__header">
        <search-header></search-header>
      </div>

      <div class="c-t-search__main-wrap">
        <div class="c-t-search__sidebar">
          <search-sidebar></search-sidebar>
        </div>
        <div class="c-t-search__main">
          <search-results></search-results>
        </div>
      </div>
    </div>
    <site-footer></site-footer>
  </div>
</template>

<script>
import { FETCH_COMPANIES, SET_CATEGORY_ACTION, SET_REGION_ACTION } from "../store/store-models/companies-model";

import ButtonAtom from "./components/atoms/AtomButton.vue";
import Pagination from "./components/molecules/MoleculePagination.vue";
import SiteFooter from "./components/organisms/OrganismSiteFooter.vue";
import SiteHeader from "./components/organisms/OrganismSiteHeader.vue";
import SearchHeader from "./components/organisms/search/OrganismSearchHeaderCompanies.vue";
import SearchResults from "./components/organisms/search/OrganismSearchResultsCompanies.vue";
import SearchSidebar from "./components/organisms/search/OrganismSearchSidebarCompanies.vue";


export default {
  async asyncData({ store, route }) {
    await store.dispatch(SET_REGION_ACTION, null);
    await store.dispatch(SET_CATEGORY_ACTION, null);
    return store.dispatch(FETCH_COMPANIES);
  },
  components: {
    SiteHeader,
    SiteFooter,
    SearchHeader,
    SearchResults,
    SearchSidebar,
    ButtonAtom,
    Pagination
  },
  metaData() {
    return {
      title: "Sök hantverkare",
      meta: [
        {
          name: "description",
          content:
            "Här kan du själv söka och välja ut upp till 5 lämpliga byggföretag som ska få din förfrågan. Om de inte svarar så skickar vi din förfrågan till några fler lämpliga företag för att du ska få upp till 6 svar att välja mellan."
        }
      ]
    };
  },

};
</script>



// WEBPACK FOOTER //
// src/views/Companies.vue